import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FAQService {
  constructor(private httpClient: HttpClient) {}

  update(id: any, payload: any): Promise<any> {
    return lastValueFrom(
      this.httpClient
        .post(`${environment.apiUrl}/faq/update/${id}`, payload)
        .pipe(map((data) => data))
    );
  }

  search(): Promise<any> {
    return lastValueFrom(
      this.httpClient
        .post(`${environment.apiUrl}/faq/search`, '')
        .pipe(map((data) => data))
    );
  }

  create(payload: any): Promise<any> {
    return lastValueFrom(
      this.httpClient
        .post(`${environment.apiUrl}/faq/create`, payload)
        .pipe(map((data) => data))
    );
  }

  delete(id: any): Promise<any> {
    return lastValueFrom(
      this.httpClient
        .delete(`${environment.apiUrl}/faq/delete/${id}`)
        .pipe(map((data) => data))
    );
  }
}
